/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieClassStudentItemViewModel } from "../types/SerieClassStudentItemViewModel.ts";

export const serieClassStudentItemViewModelSchema = z.object({
  classStudentId: z.optional(
    z.number().int().describe("ID da turma vinculada."),
  ),
  description: z.string().describe("Descrição da turma.").nullish(),
}) as unknown as ToZod<SerieClassStudentItemViewModel>;
